<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'PORTAL.GROUP_TITLE' | translate}}</h2>
    <ntr-add-button [openView]="'portal-dashboard-group/add'"></ntr-add-button>

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'portalDashboardGroup'" [modelView]="'portal-dashboard-group'" [disableHeader]="true" (onQuery)="onGridQuery($event)" (onDeleteQuery)="deleteGroup($event)" [columns]="columns"></ntr-datatable>
</div>
